class ListController {
  constructor(
    Authentication,
    AccountService,
    SubscriptionUtils,
    PersonaCollection,
    AvailabilityUtils,
    UserUtils,
    $timeout,
    $state,
    $scope,
    $rootScope,
    $location
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      AccountService,
      SubscriptionUtils,
      PersonaCollection,
      AvailabilityUtils,
      UserUtils,
      $timeout,
      $state,
      $scope,
      $rootScope,
      $location,
    });
  }

  $onInit() {
    this.user = null;
    this.init();
  }

  goToNewSet(unavailabilityCount) {
    this.$state.go('users.profile', {
      userId: this.srcUserId || this.Authentication.user.id,
      tab: 'availability',
      newSet: true,
      unavailabilityCount,
    });
  }

  goToUnavailability(unavailabilitySet, unavailabilityCount, editSet) {
    const stateName = this.isHistory ? 'users.profile.unavailability-history' : 'users.profile';
    this.$state.go(
      stateName,
      {
        userId: unavailabilitySet?.user?.id,
        tab: 'availability',
        unavailabilityId: unavailabilitySet?.id,
        unavailabilityCount,
        editSet,
      },
      { reload: true }
    );
  }

  goToHistory() {
    this.$state.go('users.profile.unavailability-history', {
      userId: this.$state.params.userId || this.Authentication.user.id,
    });
  }

  init() {
    this.user = { ...this.Authentication.user };
  }

  get canManage() {
    const user = this.PersonaCollection.personasDict[this.srcUserId];
    return user && this.UserUtils.canManageUser(user);
  }

  async approve(set) {
    const setToSave = await this.AvailabilityUtils.getSingleUnavailabilitySet(set.id);
    return this.AvailabilityUtils.approveUnavailabilitySet(setToSave);
  }

  async deny(set) {
    return this.AvailabilityUtils.denyUnavailabilitySet({ availabilityId: set.id });
  }
}

export default {
  template: `
    <div class="availability-tab-container-react">
      <unavailability-preview ng-if="!ctrl.Authentication.isOrgFeatureEnabled('unavailability')"></unavailability-preview>
      <div ng-else ng-class="{'unavailability-manager-view': ctrl.Authentication.user.isManager}">
        <r-premium-feature-banner
          ng-if="ctrl.Authentication.user.orgSettings.premiumFeatures.unavailability && ctrl.Authentication.user.isManager"
          feature="unavailability"
          current-user="ctrl.Authentication.user"
        ></r-premium-feature-banner>

        <r-unavailability-list-screen
          current-user="ctrl.user"
          go-to-set="ctrl.goToUnavailability(set, unavailabilityCount, editSet)"
          src-user-id="ctrl.srcUserId"
          go-to-new-set="ctrl.goToNewSet(unavailabilityCount)"
          go-to-history="ctrl.goToHistory()"
          is-history="ctrl.isHistory"
          approve-set="ctrl.approve(set)"
          deny-set="ctrl.deny(set)"
          can-manage="ctrl.canManage">
        </r-unavailability-list-screen>
      </div>
    </div>
    `,
  controller: ListController,
  controllerAs: 'ctrl',
  bindings: {
    srcUserId: '=',
    isHistory: '<',
  },
};
